var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    { attrs: { cols: "auto" } },
    [
      _c(
        "v-img",
        {
          staticClass: "grey lighten-2 pointer",
          staticStyle: { "border-radius": "10px" },
          attrs: {
            gradient: _vm.isChosen
              ? "to bottom right, rgba(0,0,0,.3), rgba(0,0,0,.2)"
              : "",
            src: _vm.file.url,
            width: _vm.width,
            height: "auto",
            "lazy-src": require("@/assets/images/placeholder.png"),
            "aspect-ratio": "1",
          },
          on: {
            click: function ($event) {
              return _vm.$emit("choose-file", _vm.file.id)
            },
          },
          scopedSlots: _vm._u([
            {
              key: "placeholder",
              fn: function () {
                return [
                  _c(
                    "v-row",
                    {
                      staticClass: "fill-height ma-0",
                      attrs: { align: "center", justify: "center" },
                    },
                    [
                      _c("v-progress-circular", {
                        attrs: { indeterminate: "", color: "grey lighten-5" },
                      }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm.pickerMode
            ? _c(
                "v-btn",
                { attrs: { icon: "" } },
                [
                  _c("v-icon", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.isChosen
                            ? "mdi-checkbox-marked-outline"
                            : "mdi-checkbox-unmarked-outline"
                        ) +
                        " "
                    ),
                  ]),
                ],
                1
              )
            : !_vm.hideDelete
            ? _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.$emit("remove-file", _vm.file.id)
                    },
                  },
                },
                [_c("v-icon", [_vm._v("mdi-close-circle-outline")])],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._t("body"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }